var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"branch content_area"},[_c('el-image',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":"https://attached-file.oss-cn-shanghai.aliyuncs.com/ailaworldImgs/siffa/aabbcc.png","fit":"scale-down"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }